import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-counter',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class RolesComponent {

  constructor(
    private authService: AuthService
  ) { }


  roles(): string[] {
    return this.authService.roles();
  }

}
